import { RunException } from "./exception";
import { err, type Result, type ResultError } from "./result";

function runSync<T, E extends ResultError, R extends Result<T, E>>(
	fn: () => R,
) {
	const callerStack = new Error().stack;

	try {
		const data = fn();

		if (!data.success) {
			throw new RunException(data.error.message, data.error);
		}

		return data;
	} catch (error) {
		let resultError: ResultError = {
			message: "Run sync failed",
			stack: callerStack,
		};

		if (error instanceof Error) {
			const { message, cause } = error;
			let data: unknown;

			if (error instanceof RunException) {
				data = error.data;
			}

			resultError = { ...resultError, message, cause, data };
		}

		return err(resultError);
	}
}

async function run<T, E extends ResultError, R extends Result<T, E>>(
	fn: () => Promise<R>,
) {
	const callerStack = new Error().stack;

	try {
		const data = await fn();

		if (!data.success) {
			throw new RunException(data.error.message, data.error);
		}

		return data;
	} catch (error) {
		let resultError: ResultError = {
			message: "Run failed",
			stack: callerStack,
		};

		if (error instanceof Error) {
			const { message, cause } = error;
			let data: unknown;

			if (error instanceof RunException) {
				data = error.data;
			}

			resultError = { ...resultError, message, cause, data };
		}

		return err(resultError);
	}
}

export { run, runSync };
